import React from "react";

import FlightCard from "./FlightResultCard/FlightResultCard";
import classes from "./FlightList.module.css";
import { Typography, Tooltip } from "@material-ui/core";
import { useSelector } from "react-redux";
import TabWithIcon from "./TabWithIcon";

export default function FlightList({ flights, showDetails, journeyType }) {
  const currency = useSelector((state) => state.flight.currency);

  if (journeyType === "Return") {
    // Two-way: show both depart and return in one card
    return (
      <div className={`${classes["flight-section"]} col-sm-7 col-md-9`}>
        {flights?.map((flight, idx) => (
          <div className={classes["flight-result-card"]} key={idx} tabIndex={0} aria-label={`Select depart and return flight option ${idx + 1}`}>
            <div className={classes["flight-container"]}>
              <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#129880', marginBottom: 4 }}>Depart Flight</Typography>
              <FlightCard
                route={flight.slices[0]}
                tripType="Depart"
                cityTo={flight?.cityTo}
                cityFrom={flight?.cityFrom}
              />
              {flight.slices[1] ? (
                <>
                  <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#129880', margin: '12px 0 4px 0' }}>Return Flight</Typography>
                  <FlightCard
                    route={flight.slices[1]}
                    tripType="Return"
                    cityTo={flight?.cityFrom}
                    cityFrom={flight?.cityTo}
                  />
                </>
              ) : (
                <Typography color="error" style={{ marginTop: 8 }}>
                  No return flight option available for this result.
                </Typography>
              )}
            </div>
            <div className={classes["flight-container__footer"]}>
              <div className={classes["tab-container"]}>
                {flight && flight.virtual_interlining && (
                  <TabWithIcon icon="star" text="Virtual Interlining" />
                )}
                {flight && flight?.baglimit && flight?.baglimit?.hand_weight && (
                  <TabWithIcon
                    icon="brifcase"
                    text={`${flight.baglimit.hand_weight} kg`}
                    title="Cabin Baggage"
                  />
                )}
                {flight && flight?.baglimit && flight?.baglimit?.personal_item_weight && (
                  <TabWithIcon
                    icon="work"
                    text={`${flight.baglimit.personal_item_weight} kg`}
                    title="Personal Baggage"
                  />
                )}
                {flight && flight?.baglimit && flight?.baglimit?.hold_weight && (
                  <TabWithIcon
                    icon="luggage"
                    text={`${flight.baglimit.hold_weight} kg`}
                    title="Checked Baggage"
                  />
                )}
              </div>
              <div className={classes["flight-price"]}>
                <Typography variant="h5" style={{ fontSize: "1.125rem" }}>
                  <strong>
                    {currency || "INR"} {Math.round(flight.price)}
                  </strong>
                </Typography>
                <button
                  className={classes["see-flight-btn"]}
                  onClick={showDetails.bind(this, flight, true)}
                >
                  See Flight
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // One-way: current behavior
  return (
    <div className={`${classes["flight-section"]} col-sm-7 col-md-9`}>
      {flights?.map((flight, idx) => (
        <div className={classes["flight-result-card"]} key={idx} tabIndex={0} aria-label={`Select flight option ${idx + 1}`}>
          <div className={classes["flight-container"]}>
            {flight.slices.map((slice, i) => (
              <FlightCard
                route={slice}
                tripType={i === 0 ? "Depart" : "Return"}
                cityTo={flight?.cityTo}
                cityFrom={flight?.cityFrom}
              />
            ))}
          </div>
          <div className={classes["flight-container__footer"]}>
            <div className={classes["tab-container"]}>
              {flight && flight.virtual_interlining && (
                <TabWithIcon icon="star" text="Virtual Interlining" />
              )}
              {flight && flight?.baglimit && flight?.baglimit?.hand_weight && (
                <TabWithIcon
                  icon="brifcase"
                  text={`${flight.baglimit.hand_weight} kg`}
                  title="Cabin Baggage"
                />
              )}
              {flight && flight?.baglimit && flight?.baglimit?.personal_item_weight && (
                <TabWithIcon
                  icon="work"
                  text={`${flight.baglimit.personal_item_weight} kg`}
                  title="Personal Baggage"
                />
              )}
              {flight && flight?.baglimit && flight?.baglimit?.hold_weight && (
                <TabWithIcon
                  icon="luggage"
                  text={`${flight.baglimit.hold_weight} kg`}
                  title="Checked Baggage"
                />
              )}
            </div>
            <div className={classes["flight-price"]}>
              <Typography variant="h5" style={{ fontSize: "1.125rem" }}>
                <strong>
                  {currency || "INR"} {Math.round(flight.price)}
                </strong>
              </Typography>
              <button
                className={classes["see-flight-btn"]}
                onClick={showDetails.bind(this, flight, true)}
              >
                See Flight
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
